export const isDesktopLayout = { minWidth: 1024 };
export const isMobileLayout = { maxWidth: 1023 };
